import { render, staticRenderFns } from "./KBTextarea.vue?vue&type=template&id=c3b03f74&scoped=true&"
import script from "./KBTextarea.vue?vue&type=script&lang=js&"
export * from "./KBTextarea.vue?vue&type=script&lang=js&"
import style0 from "./KBTextarea.vue?vue&type=style&index=0&id=c3b03f74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b03f74",
  null
  
)

export default component.exports